<template>
  <div>
    <div
      v-if="routeId"
      class="pvd-container pvd-btn-row"
    >
      <div
        v-if="showPrimaryAction === 'Yes'"
        class="button-group"
      >
        <button
          v-if="isCustomer !== 'Yes'"
          id="primaryAction"
          type="button"
          :disabled="isPrimaryActionDisabled"
          class="pvd-btn btn-action loading-button"
          @click.prevent="handlePrimaryClick(pd_content.primary_button.value)"
        >
          <pvd-loading-spinner
            v-if="showSpinner && cs_stateName !== 'review-and-confirm'"
            :active="showSpinner"
            type="white"
            inline="true"
          />
          {{ primaryButtonText }}
        </button>
        <button
          v-if="isCustomer === 'Yes'"
          type="submit"
          class="pvd-btn btn-action loading-button"
        >
          <pvd-loading-spinner
            v-if="showSpinner"
            :active="showSpinner"
            type="white"
            inline="true"
          />
          {{ primaryButtonText }}
        </button>
        <button
          v-if="showPrevious"
          id="secondaryAction"
          type="button"
          class="pvd-btn btn-default"
          @click.prevent="handleSecondaryClick(pd_content.secondary_button.value)"
        >
          {{ secondaryButtonText }}
        </button>
      </div>
      <p
        v-if="!isMaestro() && !isLiteView()"
        class="tertiary-link xsmall"
      >
        <a
          v-if="routeId === 'iStock'"
          :href="pd_content.exit_link.url"
          @click="handleExitClick"
        >{{ pd_content.exit_link.value }}</a>
        <a
          v-else
          id="exit-overlay-modal-trigger"
          href="javascript:void(0)"
          @click="handleExitClick"
        >{{ pd_content.exit_link.value }}</a>
      </p>
    </div>
    <ModalComponent
      v-if="routeId !== 'iStock'"
      :modal-header="pd_content.exit_overlay_modal_header"
      :modal-body1="pd_content.exit_overlay_modal_body1"
      :modal-body2="pd_content.exit_overlay_modal_body2"
      :modal-footer="pd_content.exit_overlay_modal_footer"
      :modal-btn-url="getExitUrl"
      :modal-btn-val="pd_content.overlay_exit_link.value"
      id-val="exit-overlay-modal"
      @close-action="closeModal"
      @exitmodal-action="exitOverlayModal"
    />
    <apx-page-loading-spinner
      v-if="routeId !== 'iStock'
        && showSpinner
        && (cs_stateName === 'review-and-confirm' || cs_stateName === 'trust-review-and-confirm' || cs_stateName === 'final-page-irrl')"
    />
  </div>
</template>

<script>
// import axios from 'axios';
import dataHelper from '../mixins/dataHelper';
import measurement from '../mixins/measurement';
import navHelper from '../mixins/navHelper';
import utilityFunctions from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';
import ModalComponent from './ModalComponent.vue';
import constants from '../mixins/constants';

export default {
  name: 'NavigationComponent',
  components: {
    ModalComponent,
  },
  mixins: [
    dataHelper,
    measurement,
    navHelper,
    utilityFunctions,
    validationHelper,
  ],
  inject: ['$validator'],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    isCustomer: String,
    showPrimaryAction: {
      type: String,
      default: () => 'Yes',
    },
    isPrimaryAlone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isPrimaryActionDisabled: false,
      pageContainsInvalidFields: false,
      preventRep: false,
    };
  },
  computed: {
    showSpinner() {
      return this.isPrimaryActionDisabled && !this.preventRep;
    },
    showPrevious() {
      let showPrevious = true;
      if (this.routeId === 'trust' && this.cs_stateName === 'personal-information' && this.isMaestro()) {
        showPrevious = false;
      } else if (!this.cs_editMode) {
        if (this.routeId !== 'youth' && ((this.isExpressCustomerFlow()) || ((this.routeId === 'brokerage' || this.routeId === 'fcma') && this.cs_stateName === 'employment-information'))) {
          showPrevious = false;
        } else {
          showPrevious = this.pd_pageData.showPreviousStates.indexOf(this.cs_stateName) > -1;
        }
        if (this.isManagedAccount() && (this.isJoint() || this.isTrust) && this.pu_flowType === constants.FLOW_TYPES.EXPRESS) {
          showPrevious = true;
        }
        if (this.isManagedAccount() && this.cs_stateName === 'personal-information') {
          showPrevious = false;
        }
      }
      return showPrevious;
    },
    primaryButtonText() {
      const buttonText = this.pd_content.primary_button.default;
      if (this.isPrimaryActionDisabled && !this.preventRep) {
        return this.pd_content.primary_button.wait;
      }
      if (this.cs_editMode && this.routeId !== 'trust') {
        return this.pd_content.primary_button.edit;
      }
      if (this.cs_stateName === 'review-and-confirm' && this.routeId !== 'youth') {
        return this.pd_content.primary_button.confirm;
      }
      if (this.cs_stateName === 'agree-to-terms') {
        return this.pd_content.primary_button.open;
      }
      if (this.cs_stateName === 'trust-review-and-confirm' && !this.isPrimaryAlone) {
        return this.pd_content.primary_button.agree;
      }
      if (this.cs_stateName === 'trust-review-and-confirm' && this.isPrimaryAlone) {
        return 'Open Account';
      }
      if (this.cs_stateName === 'trust-doc-verify-initiate') {
        return this.pd_content.primary_button.start_id_check;
      }
      if (this.cs_stateName === 'trust-doc-verify-wait') {
        return this.pd_content.primary_button.verify_wait;
      }
      if (this.cs_stateName === 'trust-doc-verify-resend-sms') {
        return this.pd_content.primary_button.resend_sms_link;
      }
      if (this.cs_stateName === 'trust-doc-verify-not-complete') {
        return this.pd_content.primary_button.retry;
      }
      if (['trust-identity-verification-failure', 'trust-identity-check-fail'].includes(this.cs_stateName)) {
        return this.pd_content.primary_button.exit_application;
      }
      if (this.cs_stateName === 'trust-customer-contact-mismatch' || this.cs_stateName === 'trust-customer-identity-mismatch') {
        return this.pd_content.primary_button.try;
      }
      if (this.cs_stateName === 'trust-customer-not-found') {
        return this.pd_content.primary_button.close;
      }
      if (this.cs_stateName === 'trust-additional-role') {
        return this.cs_editMode ? this.pd_content.primary_button.edit : this.pd_content.primary_button.default;
      }
      if (this.cs_stateName === 'trust-information') {
        return this.cs_editMode ? this.pd_content.primary_button.edit : this.pd_content.primary_button.default;
      }

      return buttonText;
    },
    secondaryButtonText() {
      let buttonText = this.pd_content.secondary_button.default;
      if (this.cs_editMode && this.routeId !== 'trust') {
        buttonText = this.pd_content.secondary_button.edit;
      }
      if (this.cs_stateName === 'trust-additional-role' && this.cs_editMode) {
        return this.cs_editMode ? this.pd_content.secondary_button.edit : this.pd_content.secondary_button.default;
      }
      if (this.cs_stateName === 'trust-information' && this.cs_editMode) {
        return this.cs_editMode ? this.pd_content.secondary_button.edit : this.pd_content.secondary_button.default;
      }
      return buttonText;
    },

    getExitUrl() {
      let returnVal;
      const regType = this.getRegType(document.location.pathname);
      if (this.cs_stateName === 'customer-igo' && regType !== constants.ROLLOVERIRA_REGTYPE) {
        returnVal = this.pd_envConfig.portfolioSummaryUrl;
      } else if (this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.exitURL) {
        if (this.$globalData.tStoreResponse.exitURL.method === 'POST') {
          returnVal = { url: this.$globalData.tStoreResponse.exitURL.url, method: 'POST' };
        } else {
          returnVal = this.$globalData.tStoreResponse.exitURL.url;
        }
      } else {
        returnVal = this.pd_content.overlay_exit_link.all_accounts_url;
      }
      return returnVal;
    },
  },
  created() {
    this.$parent.$on('invoke-next-page', (navAction) => {
      this.invokeApiAndNavigateToNextPage(navAction);
    });
    this.$parent.$on('invoke-previous', () => this.handleSecondaryClick('previous'));
    document.addEventListener('value-changed', (ev) => this.setInvalidFieldOnPage(ev));
    if (this.uc_isRep && (this.cs_stateName === 'review-and-confirm' || this.cs_stateName === 'trust-review-and-confirm')) {
      this.isPrimaryActionDisabled = true;
      this.preventRep = true;
    }
  },
  methods: {
    closeModal() {
      this.track('overlay_close_modal', 'interaction');
      document
        .querySelector('#exit-overlay-modal')
        .setAttribute('active', 'false');
    },
    exitOverlayModal(url) {
      this.track('overlay_exit_link', 'interaction');
      if (typeof url === 'object') {
        this.submitForm(
          this.createForm(url.url, (
            this.$globalData.tStoreResponse && this.$globalData.tStoreResponse.params) ? this.$globalData.tStoreResponse.params : ''),
        );
      } else {
        window.location.assign(url);
      }
    },

    handlePrimaryClick(navAction) {
      this.resetInvalidFieldOnPage();
      const validatedres = this.validateAllFields();
      const self = this;
      this.$validator.validateScopes().then((isValid) => {
        if (isValid && self.pageContainsInvalidFields === false && validatedres === true) {
          self.dispatchNextButtonClick();
          self.resetAssociationAndControlPerson();
          self.openAccountActionInProgress();
          self.saveHTML(self.$route.name);
          self.navigateState(navAction);
        } else {
          self.track(`nav-${navAction}-error`, 'interaction');
          self.$_setFocus();
        }
      });
    },
    handleSecondaryClick(navAction) {
      this.navigateState(navAction);
    },
    handleExitClick() {
      this.track('exit-link', 'interaction');
    },
    invokeApiAndNavigateToNextPage(navAction) {
      this.$store.commit('currentState/updateField', {
        path: 'navAction',
        value: navAction,
      });
      this.routeEngine(this.getInstanceData());
    },
    navigateState(navAction) {
      if (navAction !== 'next') {
        this.track(`nav-${this.getInteraction(navAction)}`, 'interaction');
      }
      // if (navAction === 'previous' && this.getInstanceData().currentState.futureDestinationState === 'trust-ssn-mismatch') {
      //   this.invokeApiAndNavigateToNextPage('grantorOnlyOrEditModeSM');
      // }

      if (this.cs_stateName === 'final-page') {
        window.location.assign(this.rc_exitUrl);
      } else if (this.cs_stateName === 'final-page-irrl' || this.cs_stateName === 'trust-final-page') {
        if (this.rc_riskData && this.rc_riskData.userType === 'InActiveCustomerWithCredentials') {
          this.$store.commit('currentState/updateField', {
            path: 'stateName',
            value: 'password-reset-instructions',
          });
          this.invokeApiAndNavigateToNextPage(navAction);
        } else {
          this.submitNURForm();
        }
      } else if (this.cs_stateName === 'customer-igo') {
        this.submitIgoForm();
      } else if (
        this.shouldCall2FAWidget(
          this.cs_stateName,
          this.uc_isCustomer,
          this.uc_isRep,
          this.routeId,
        )
        && navAction === 'next'
      ) {
        this.$emit('next-action', navAction);
      } else if (this.cs_stateName === 'trust-review-and-confirm' && this.isPrimaryAlone && navAction === 'next') {
        this.track('open-account-single-signer', 'interaction');
        this.invokeApiAndNavigateToNextPage('singleSignerOpeningAccount');
      } else {
        this.invokeApiAndNavigateToNextPage(navAction);
      }
    },
    getInteraction(navAction) {
      let interactionName = navAction;
      if (this.cs_editMode && navAction === 'next') {
        interactionName = 'save';
      } else if (this.cs_editMode && navAction === 'previous') {
        interactionName = 'cancel';
      }
      return interactionName;
    },
    submitNURForm() {
      if (this.pu_ssn) {
        this.$parent.$refs.ssn.value = this.pu_ssn.replace(/-/g, '');
      }
      if (this.cs_stateName === 'trust-final-page') {
        this.$store.commit('currentState/updateField', {
          path: 'currentState',
          value: 'trust-final-page',
        });
        this.$store.commit('currentState/updateField', {
          path: 'navAction',
          value: 'next',
        });
      }
      this.$parent.$refs.dob.value = this.pu_dob;
      this.$parent.$refs.zip.value = this.pu_leg_zip;
      this.$parent.$refs.account.value = this.rc_accountNumber;
      this.$parent.$refs.nurForm.submit();
    },
    submitIgoForm() {
      let regType;
      let n;
      const str = document.location.pathname;
      if (str) {
        n = str.lastIndexOf('/');
        regType = str.substr(n + 1);
      }
      this.$parent.$refs.regType.value = regType;
      if (regType === 'rolloverIRA') {
        this.$parent.$refs.igoForm.action = this.pd_envConfig.toaURL;
      } else {
        this.$parent.$refs.igoForm.action = this.pd_envConfig.portfolioSummaryUrl;
      }
      this.$parent.$refs.igoForm.submit();
    },
    $_setFocus() {
      const errorElements = '.input-error, input[aria-invalid]:not([aria-invalid="false"]), select[aria-invalid]:not([aria-invalid="false"])';
      const firstErrorElement = this.$parent.$el.querySelector(errorElements);
      if (!!window.MSInputMethodContext && !!document.documentMode) {
        setTimeout(() => {
          firstErrorElement.focus();
        }, 5);
      } else {
        firstErrorElement.focus();
      }
    },
    saveHTML(state) {
      const needsArchive = [
        'review-and-confirm',
        'review-and-confirm-is',
        'agree-to-terms',
      ];
      if (needsArchive.includes(state)) {
        const archiveHTML = this.captureHTML();
        switch (state) {
          case 'review-and-confirm-is':
          case 'review-and-confirm':
            this.pu_reviewAndConfirmHTML = this.saveRCPageUserInputs(
              archiveHTML,
              this.pu_cashPosition,
              this.routeId === 'youth' ? this.su_taxWithHolding : this.pu_taxWithHolding,
            );
            break;
          case 'agree-to-terms':
            this.pu_agreeTermsHTML = this.saveUserInputs(
              archiveHTML,
              this.pu_taxWithHolding,
            );
            break;
          default:
            break;
        }
      }
    },
    resetInvalidFieldOnPage() {
      this.pageContainsInvalidFields = false;
    },
    setInvalidFieldOnPage(ev) {
      if (ev.detail && ev.detail.valid === false) {
        this.pageContainsInvalidFields = true;
      }
    },
    openAccountActionInProgress() {
      if (
        this.cs_stateName === 'agree-to-terms'
        || this.cs_stateName === 'personal-information'
        || this.cs_stateName === 'review-and-confirm'
        || this.cs_stateName === 'trust-login'
        || this.cs_stateName === 'employment-information'
        || this.cs_stateName === 'trust-additional-role'
        || this.cs_stateName === 'trust-review-and-confirm'
        || this.cs_stateName === 'trust-doc-verify-initiate'
        || this.cs_stateName === 'trust-doc-verify-wait'
        || this.cs_stateName === 'trust-doc-verify-resend-sms'
        || this.cs_stateName === 'trust-identity-verification-failure'
        || this.cs_stateName === 'trust-identity-check-fail'
        || this.cs_stateName === 'trust-customer-contact-mismatch'
        || this.cs_stateName === 'trust-customer-identity-mismatch'
      ) {
        this.isPrimaryActionDisabled = true;
        this.$emit('open-account-button-clicked', true);
      }
    },
    resetAssociationAndControlPerson() {
      if (this.cs_stateName === 'employment-information') {
        if (!this.pu_coAffillCode || this.pu_coAffillCode === 'No') {
          this.commitPrimaryUserData('', 'coAffillName');
        }
        if (!this.pu_coDirectorCode || this.pu_coDirectorCode === 'No') {
          this.commitPrimaryUserData('', 'coDirectorSymbol');
        }
      }
    },
    dispatchNextButtonClick() {
      this.$emit('next-buttton-clicked');
    },
    isExpressCustomerFlow() {
      return this.pu_flowType === constants.FLOW_TYPES.EXPRESS && this.uc_isCustomer;
    },
    isManagedAccount() {
      return this.isManaged(this.routeId);
    },
    isJoint() {
      switch (this.pd_pageData.tStoreResponse.params.regType) {
        case 'J':
        case 'TIC':
        case 'JTIC':
          return true;
        default:
          return false;
      }
    },
    isTrust() {
      switch (this.pd_pageData.tStoreResponse.params.regType) {
        case 'RT':
        case 'IRT':
          return true;
        default:
          return false;
      }
    },
  },
};
</script>

<style lang="scss">
.pvd-btn-row .button-group button.loading-button {
  flex-direction: row;
}
</style>
